import whenDomReady from "when-dom-ready";
import { initPage } from "../pages/base/revenue_disclosure_modal";

whenDomReady()
  .then(() => {
    initPage();
  })
  .catch((error) => {
    console.error("Error initializing revenue disclosure:", error);
  });
